/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Hubspot_Readings_HeldInputs */

const en_queue_hubspot_readings_held = /** @type {(inputs: Queue_Hubspot_Readings_HeldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HubSpot readings to decide`)
};

/**
* | output |
* | --- |
* | "HubSpot readings to decide" |
*
* @param {Queue_Hubspot_Readings_HeldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_hubspot_readings_held = /** @type {((inputs?: Queue_Hubspot_Readings_HeldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Hubspot_Readings_HeldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_hubspot_readings_held(inputs)
});